import { LitElement, html, css, unsafeCSS, property } from "lit-element";

import { seriesApi } from "../../api/seriesApi";

import { DropdownModel } from "../../models/components/DropdownModel";
import { SeriesModel } from "../../models/media/SeriesModel";

import Dropdown from "../dropdown/dropdown";

import playerCareerReportStyles from "./player-career-report.scss";
import { TeamModel } from "../../models/media/TeamModel";
import { teamsApi } from "../../api/teamsApi";
import { playersApi } from "../../api/playersApi";
import { PlayerModel, PlayerSeasonHistoryModel } from "../../models/media/PlayerModel";
import ScoreTypes from "../../enums/score-types";
import { seasonsApi } from "../../api/seasonsApi";
import { SeasonModel } from "../../models/media/SeasonModel";

export default class PlayerCareerReport extends LitElement {
    @property({ type: Array })
    seriesList: SeriesModel[];

    @property({ type: Array })
    seasons: SeasonModel[];

    @property({ type: Array })
    teams: TeamModel[];

    @property({ type: Array })
    players: PlayerModel[];

    @property({ type: Object })
    selectedSeries: SeriesModel;

    @property({ type: Object })
    selectedSeason: SeasonModel;

    @property({ type: Object })
    selectedTeam: TeamModel;

    @property({ type: Object })
    renderSeries: SeriesModel;

    @property({ type: Object })
    renderTeam: TeamModel;

    @property({ type: Object })
    renderSeason: SeasonModel;

    private _mediaUrl = "";
    private _userId = "";

    private _teamsApi: teamsApi;
    private _playersApi: playersApi;
    private _seriesApi: seriesApi;
    private _seasonsApi: seasonsApi;

    private _showSubHistory: boolean = true;

    constructor(
        mediaUrl: string,
        userId: string) {
        super();

        this._mediaUrl = mediaUrl;
        this._userId = userId;

        this._teamsApi = new teamsApi(this._mediaUrl, this._userId);
        this._playersApi = new playersApi(this._mediaUrl, this._userId);
        this._seriesApi = new seriesApi(this._mediaUrl, this._userId);
        this._seasonsApi = new seasonsApi(this._mediaUrl, this._userId);

        this.seriesList = [];
        this.teams = [];
        this.seasons = [];
        this.players = [];
    }

    async firstUpdated() {

        this.showLoading(true, document.querySelector('#loading-container'));

        this.seriesList = await this._seriesApi.getSeriesList('', []);

        this.showLoading(false, document.querySelector('#loading-container'));
    }

    textSort(a, b, property) {
        let aProp = a ? a[property] : 0;
        let bProp = b ? b[property] : 0;

        let returnValue = 0;

        if (aProp < bProp)
            returnValue = -1;
        else
            returnValue = 1;

        return returnValue;
    }

    getSeriesList() {
        let dropdownItems: DropdownModel[] = [];

        dropdownItems.push(new DropdownModel(undefined, "Please select a Series", null));
        for (let [i, series] of Object.entries(this.seriesList)) {
            dropdownItems.push(new DropdownModel(series.seriesGuid, series.name, series));
        }

        let selectedValue = this.selectedSeries ? this.selectedSeries.seriesGuid : undefined;

        return new Dropdown(dropdownItems, this.seriesChange, selectedValue, "Series");
    }

    seriesChange = async (value: string, seriesModel: SeriesModel) => {
        this.selectedSeries = seriesModel;

        this.showLoading(true, document.querySelector('#loading-container'));
        [this.teams, this.seasons] =
            await Promise.all([
                this._teamsApi.GetTeams(this.selectedSeries.seriesGuid, '', '', []),
                this._seasonsApi.GetSeasonsForSeries(this.selectedSeries.seriesGuid)]);

        this.showLoading(false, document.querySelector('#loading-container'));
    }

    getSeasons() {
        let dropdownItems: DropdownModel[] = [];

        dropdownItems.push(new DropdownModel("", "Please select a Season", null));
        for (let [i, season] of Object.entries(this.seasons)) {
            dropdownItems.push(new DropdownModel(season.seasonGuid, season.seasonName, season));
        }

        let selectedValue = this.selectedSeason ? this.selectedSeason.seasonGuid : "";

        return new Dropdown(dropdownItems, this.seasonChange, selectedValue, "Season");
    }

    seasonChange = async (value: string, seasonModel: SeasonModel) => {
        if (!value) {
            this.selectedSeason = null;
            return;
        }

        this.selectedSeason = seasonModel;

        this.showLoading(true, document.querySelector('#loading-container'));

        this.teams = await this._teamsApi.GetTeamsForSeason(this.selectedSeason.seasonGuid);

        this.showLoading(false, document.querySelector('#loading-container'));
    }

    getTeams() {
        let dropdownItems: DropdownModel[] = [];

        dropdownItems.push(new DropdownModel("", "Please select a Team", null));
        for (let [i, team] of Object.entries(this.teams)) {
            dropdownItems.push(new DropdownModel(team.teamGuid, team.name, team));
        }

        let selectedValue = this.selectedTeam ? this.selectedTeam.teamGuid : "";

        return new Dropdown(dropdownItems, this.teamChange, selectedValue, "Team");
    }

    teamChange = (value: string, teamModel: TeamModel) => {
        if (!value) {
            this.selectedTeam = null;
            return;
        }

        this.selectedTeam = teamModel;
    }

    getPlayers() {
        if (!this.players || this.players.length === 0)
            return html`<div> No Players Found </div>`

        return html`
        <table class="table table-hover" id="players-career-table">
            <thead>
                <tr>
                    ${!this.selectedSeason ?
                html`<th colspan=5 class="report-title">${this.renderSeries.name} ${this.renderSeason ? html` ${this.renderSeason.seasonName}` : ''} ${this.renderTeam ? html` - <img src="https://mobiithumbnails.azureedge.net/thumbnails/live/stratus/${this.renderTeam.teamGuid}/small.png" /> ${this.renderTeam.name}` : ''} - Players Career Report</th>
                    <th colspan=1><button class="btn btn-csv-export wide-element" @click=${this.exportToCSV}> <i class="fa fa-arrow-circle-o-down"></i> Export CSV</button></th>
                    <th colspan=1><button class="btn btn-primary wide-element ${this.selectedSeason ? 'hidden' : ''}" @click=${this.toggleSubHistory}>${this._showSubHistory ? html`<i class="fa fa-eye-slash"></i> Hide` : html`<i class="fa fa-eye"></i> Show`} Seasons</button></th>` :
                html`<th colspan=6 class="report-title">${this.renderSeries.name} ${this.renderSeason ? html` ${this.renderSeason.seasonName}` : ''} ${this.renderTeam ? html` - <img src="https://mobiithumbnails.azureedge.net/thumbnails/live/stratus/${this.renderTeam.teamGuid}/small.png" /> ${this.renderTeam.name}` : ''} - Players Career Report</th>
                    <th colspan=1><button class="btn btn-csv-export wide-element" @click=${this.exportToCSV}> <i class="fa fa-arrow-circle-o-down"></i> Export CSV</button></th>
                    `}                    
                </tr>
                <tr>
                    <th class="player-id-col hidden">Player ID</th>
                    <th @click="${(event) => this.headerClick(event, 100)}">First Name</th>
                    <th @click="${(event) => this.headerClick(event, 99)}">Last Name</th>
                    <th @click="${(event) => this.headerClick(event, 98)}">Points</th>
                    <th @click="${(event) => this.headerClick(event, 6)}">${ScoreTypes.getScoreType(6).name}</th>
                    <th @click="${(event) => this.headerClick(event, 1)}">${ScoreTypes.getScoreType(1).name}</th>
                    <th @click="${(event) => this.headerClick(event, 3)}">${ScoreTypes.getScoreType(3).name}</th>
                    <th @click="${(event) => this.headerClick(event, 4)}">${ScoreTypes.getScoreType(4).name}</th>
                    <th @click="${(event) => this.headerClick(event, 5)}">${ScoreTypes.getScoreType(5).name}</th>
                </tr>
            </thead>
            <tbody>

            ${this.players.map((player) => html`
                <tr class="player-row">
                    <td class="hidden">${player.playerGuid}</td>
                    <td><strong>${player.firstName}</strong></td>
                    <td><strong>${player.lastName}</strong></td>
                    <td>${(player.playerPoints && player.playerPoints !== 0) ? player.playerPoints : '-'}</td>
                    <td>${this.showPlayerScore(player, 6)}</td>
                    <td>${this.showPlayerScore(player, 1)}</td>
                    <td>${this.showPlayerScore(player, 3)}</td>
                    <td>${this.showPlayerScore(player, 4)}</td>
                    <td>${this.showPlayerScore(player, 5)}</td>
                </tr>

                ${player.playerCareerHistory.map((season) => html`
                <tr class="sub-row ${this._showSubHistory ? "" : "hidden"}">
                    <td><img title="${season.teamName}" src="https://mobiithumbnails.azureedge.net/thumbnails/live/stratus/${season.teamId}/small.png" /> ${season.seriesName}</td>
                    <td>${season.seasonName}</td>
                    <td>${(season.totalPoints && season.totalPoints !== 0) ? season.totalPoints : '-'}</td>
                    <td>${this.showPlayerSeasonScore(season, 6)}</td>
                    <td>${this.showPlayerSeasonScore(season, 1)}</td>
                    <td>${this.showPlayerSeasonScore(season, 3)}</td>
                    <td>${this.showPlayerSeasonScore(season, 4)}</td>
                    <td>${this.showPlayerSeasonScore(season, 5)}</td>
                </tr>`)}

            </tbody>`)}
        </table>`;
    }

    showPlayerScore(player: PlayerModel, scoreType: number) {
        let score = player.matchTeamPlayer.playerScoreSummary.find(x => x.scoreTypeId === scoreType);

        return (!score || score.count === 0) ? '-' : score.count;
    }

    showPlayerSeasonScore(season: PlayerSeasonHistoryModel, scoreType: number) {
        let score = season.playerSeasonScoreSummary.find(x => x.scoreTypeId === scoreType);

        return (!score || score.count === 0) ? '-' : score.count;
    }

    exportToCSV = () => {
        let table = document.getElementById('players-career-table');
        let headers = table.querySelectorAll('tr:nth-child(2) th');
        let tableBody = table.querySelector('tbody');
        let rows = tableBody.querySelectorAll('tr');

        let csvContent = "data:text/csv;charset=utf-8,";


        for (let [i, header] of Object.entries(headers)) {
            csvContent += `${header.textContent},`
        }

        csvContent += "\n";

        for (let [i, row] of Object.entries(rows)) {
            let childNodes = row.getElementsByTagName('td');

            if (row.classList.contains('hidden') && !row.classList.contains('player-id-col'))
                continue;

            for (let [i, childNode] of Object.entries(childNodes)) {
                if (childNode.textContent === '-')
                    csvContent += `0,`
                else
                    csvContent += `${childNode.textContent},`
            }

            csvContent += "\n";
        }

        let fileName = `${this.renderSeries.name}${this.renderSeason ? `${this.renderSeason.seasonName}` : ''} ${this.renderTeam ? `- ${this.renderTeam.name}` : ''} - Players Career Report`;
        let encodedUri = encodeURI(csvContent);
        let link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", `${fileName}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    toggleSubHistory = () => {
        this._showSubHistory = !this._showSubHistory;
        this.requestUpdate();
    }

    loadPlayers = async () => {
        this.showLoading(true, document.querySelector('#loading-container'));
        this.players = [];

        if (!this.selectedSeries) {
            document.querySelector('#loading-container').innerHTML = 'Please select a Series'
            return;
        }

        this.renderSeries = this.selectedSeries;
        this.renderSeason = this.selectedSeason;
        this.renderTeam = this.selectedTeam;
        this._showSubHistory = this.renderSeason ? false : true;

        this.players = await this._playersApi.GetPlayersWithScoreSummaries(this.renderSeries.seriesGuid, this.renderSeason?.seasonGuid ?? '', true, true, true, (this.renderTeam ? [this.renderTeam.teamGuid] : []));

        this.players.sort((a, b) => this.textSort(a, b, "firstName"));

        this.showLoading(false, document.querySelector('#loading-container'));
    }

    headerClick(event, scoreType) {
        let table = document.getElementById('players-career-table');
        let headers = table.querySelectorAll('tr:nth-child(2) th');

        let header: Element;

        switch (scoreType) {
            // Ignore first hidden player id col
            case 100: header = headers[1]; break;
            case 99: header = headers[2]; break;
            case 98: header = headers[3]; break;
            case 6: header = headers[4]; break;
            case 1: header = headers[5]; break;
            case 3: header = headers[6]; break;
            case 4: header = headers[7]; break;
            case 5: header = headers[8]; break;
            default: return;
        }

        let direction = header.getAttribute('direction');

        switch (scoreType) {
            case 100:
                direction === 'asc' ? this.players.sort((a, b) => this.textSort(a, b, "firstName")) : this.players.sort((a, b) => this.textSort(b, a, "firstName"));
                break;
            case 99:
                direction === 'asc' ? this.players.sort((a, b) => this.textSort(a, b, "lastName")) : this.players.sort((a, b) => this.textSort(b, a, "lastName"));
                break;
            case 98:
                direction === 'asc' ? this.players.sort((a, b) => this.textSort(a, b, "playerPoints")) : this.players.sort((a, b) => this.textSort(b, a, "playerPoints"));
                this.players.map((player) => direction === 'asc' ? player.playerCareerHistory.sort((a, b) => this.textSort(a, b, "totalPoints")) : player.playerCareerHistory.sort((a, b) => this.textSort(b, a, "totalPoints")));
                break;
            case 1:
            case 3:
            case 4:
            case 5:
            case 6:
                direction === 'asc' ? this.players.sort((a, b) => this.textSort(a.matchTeamPlayer.playerScoreSummary.find(x => x.scoreTypeId === scoreType), b.matchTeamPlayer.playerScoreSummary.find(x => x.scoreTypeId === scoreType), "count"))
                    : this.players.sort((a, b) => this.textSort(b.matchTeamPlayer.playerScoreSummary.find(x => x.scoreTypeId === scoreType), a.matchTeamPlayer.playerScoreSummary.find(x => x.scoreTypeId === scoreType), "count"));

                this.players.map((player) => direction === 'asc' ?
                    player.playerCareerHistory.sort((a, b) => this.textSort(a.playerSeasonScoreSummary.find(x => x.scoreTypeId === scoreType), b.playerSeasonScoreSummary.find(x => x.scoreTypeId === scoreType), "count")) :
                    player.playerCareerHistory.sort((a, b) => this.textSort(b.playerSeasonScoreSummary.find(x => x.scoreTypeId === scoreType), a.playerSeasonScoreSummary.find(x => x.scoreTypeId === scoreType), "count")));
                break;
        }

        Array.from(headers).map(function (header) {
            header.removeAttribute('direction');
            header.classList.remove('asc');
            header.classList.remove('desc');
        });

        let sortIconElements = document.getElementsByClassName('sort-icon');
        while (sortIconElements.length > 0) {
            sortIconElements[0].parentNode.removeChild(sortIconElements[0]);
        }

        let newDirection = direction === 'asc' ? 'desc' : 'asc';
        header.setAttribute('direction', newDirection);
        header.classList.add(newDirection);
        header.innerHTML += direction === 'asc' ? ` <i class="fa fa-chevron-circle-up sort-icon"></i>` : ` <i class="fa fa-chevron-circle-down sort-icon"></i>`;

        this.requestUpdate();
    }

    showLoading(isLoading: boolean, container: HTMLElement) {
        if (isLoading) {
            container.innerHTML = "Loading...";
        }
        else {
            container.innerHTML = "";
        }
    }

    createRenderRoot() {
        return this;
    }

    render() {

        return [
            html`
            <style>
                ${css`${unsafeCSS(playerCareerReportStyles)}`}                     
            </style>

            <div class="container">                

                <div class="row">  
                    <div class="col">
                        ${this.seriesList.length > 0 ? this.getSeriesList() : ''}
                    </div>  
    
                    <div class="col">
                        ${this.seasons.length > 0 ? this.getSeasons() : ''}
                    </div>  

                    <div class="col">
                        ${this.teams.length > 0 ? this.getTeams() : ''}
                    </div>      
                    
                    <div class="col button-col">
                        ${this.selectedSeries ? html`<button class="btn btn-info wide-element" @click=${this.loadPlayers}>Load Report</button>` : ''}
                    </div>

                </div>

                <div id="loading-container" class="row">

                </div>

                <div id="players-row" class="row">
                    ${this.players.length > 0 ? this.getPlayers() : ''}
                </div>

            </div>`
        ];
    }
}

window.customElements.define('player-career-report', PlayerCareerReport as any);